import MDeepBadgeAurora from './m-deep-badge-aurora.vue'
import MDeepBadgeCrimson from './m-deep-badge-crimson.vue'
import MDeepBadgeGold from './m-deep-badge-gold.vue'
import MDeepBadgeJade from './m-deep-badge-jade.vue'
import MDeepBadgeOutline from './m-deep-badge-outline.vue'
import MDeepBadgePulse from './m-deep-badge-pulse.vue'

export {
  MDeepBadgeAurora,
  MDeepBadgeCrimson,
  MDeepBadgeGold,
  MDeepBadgeJade,
  MDeepBadgeOutline,
  MDeepBadgePulse,
}

/** 角标类型与设计稿对应关系 */
export const DEEP_BADGE_TYPE_MAP = {
  gold: MDeepBadgeGold, // A · 黑金奢华（推荐）
  aurora: MDeepBadgeAurora, // B · 极光紫蓝
  jade: MDeepBadgeJade, // C · 墨玉绿
  crimson: MDeepBadgeCrimson, // D · 暗夜红
  outline: MDeepBadgeOutline, // E · 极简描边
  pulse: MDeepBadgePulse, // F · 双层叠加
} as const

export type DeepBadgeType = keyof typeof DEEP_BADGE_TYPE_MAP
